import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { resolveImageUrl } from '../utils/imageUrl';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ProductsPage = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await axios.get(`${API}/products`);
      setProducts(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching products:', error);
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="container mx-auto px-4 py-12">
      <div className="mb-8">
        <h1 className="text-4xl font-bold mb-4" data-testid="products-page-title">Our Products</h1>
        <p className="text-gray-600 text-lg">
          Browse our complete selection of high-quality refrigerants. Volume discounts available!
        </p>
      </div>

      {loading ? (
        <div className="text-center py-12">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {products.map((product) => {
            const oos = !product.in_stock;
            return (
            <div
              key={product.id}
              className={`bg-white rounded-lg shadow-md overflow-hidden product-card ${oos ? 'opacity-75' : ''}`}
              data-testid={`product-card-${product.id}`}
            >
              <div className="relative h-56 bg-gray-100 overflow-hidden">
                <img
                  src={resolveImageUrl(product.image_url)}
                  alt={product.full_name}
                  className={`w-full h-full object-cover ${oos ? 'grayscale' : ''}`}
                />
                <div className="absolute top-3 right-3 bg-blue-600 text-white px-4 py-2 rounded-full text-sm font-bold">
                  {product.name} - {product.weight}
                </div>
                {oos && (
                  <div className="absolute inset-0 bg-black/30 flex items-center justify-center" data-testid={`oos-overlay-${product.id}`}>
                    <span className="bg-red-600 text-white px-4 py-2 rounded-lg font-bold tracking-wider shadow-lg">OUT OF STOCK</span>
                  </div>
                )}
              </div>
              <div className="p-6">
                <h3 className="text-xl font-semibold mb-2">{product.full_name}</h3>
                <p className="text-gray-600 text-sm mb-4">{product.description}</p>

                {/* Price tiers preview */}
                <div className="mb-4 bg-gray-50 p-3 rounded">
                  <p className="text-sm font-semibold text-gray-700 mb-2">Volume Pricing:</p>
                  <div className="space-y-1 text-sm text-gray-600">
                    <p>1 pc: <span className="font-semibold">${product.price_tiers[0].price}</span></p>
                    <p>10+ pcs: <span className="font-semibold">${product.price_tiers[1]?.price}</span> each</p>
                    <p className="text-xs text-blue-600">More discounts available →</p>
                  </div>
                </div>

                {oos ? (
                  <button
                    disabled
                    className="block w-full text-center bg-gray-300 text-gray-500 px-6 py-3 rounded-lg font-semibold cursor-not-allowed"
                    data-testid={`oos-button-${product.id}`}
                  >
                    Out of Stock
                  </button>
                ) : (
                  <Link
                    to={`/products/${product.id}`}
                    className="block w-full text-center bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition font-semibold"
                  >
                    View Details & Add to Cart
                  </Link>
                )}
              </div>
            </div>
            );
          })}
        </div>
      )}
      </div>
    </div>
  );
};

export default ProductsPage;